import { DestructiveButton } from 'ui/button';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'ui/modal';

export const modalContent = {
  modalConfirm: 'Yes, Delete',
  modalHeader: 'Delete Messages',
  modalText: (medium: string, n: number) => {
    if (n > 1) {
      return `You're about to delete ${n} ${medium} messages. Are you sure want to delete these messages?`;
    }
    return `You're about to delete ${n} ${medium} message. Are you sure want to delete this message?`;
  },
};

type DeleteScheduledMessagesModalProps = {
  closeModal: () => void;
  isOpen: boolean;
  /** the active messages medium */
  medium: string;
  /** the number of active messages (selected / all) */
  numMessages: number;
  /** success action for modal */
  primaryAction: () => void;
};

export const DeleteScheduledMessagesModal = ({
  closeModal,
  isOpen,
  medium,
  numMessages,
  primaryAction,
}: DeleteScheduledMessagesModalProps) => {
  const modalText = modalContent.modalText(medium, numMessages);

  return isOpen ? (
    <Modal id="deleteScheduledMessagesModal" onClose={closeModal} isModalOpen={isOpen}>
      <ModalHeader>{modalContent.modalHeader}</ModalHeader>
      <ModalBody>{modalText}</ModalBody>
      <ModalFooter hasCancel onClose={closeModal}>
        <DestructiveButton
          onClick={() => {
            primaryAction();
            closeModal();
          }}
        >
          {modalContent.modalConfirm}
        </DestructiveButton>
      </ModalFooter>
    </Modal>
  ) : null;
};
